import { Action } from '@ngrx/store';
import { BidResultsWithType } from '../bid-results/state';

export enum DealCardsBidResultsActionTypes {
  LoadDealCardsBidResults = '[Deal Cards Bid Results] Load',
  LoadDealCardsBidResultsSuccess = '[Deal Cards Bid Results] Load Success',
  LoadDealCardsBidResultsFail = '[Deal Cards Bid Results] Load Fail'
}

export class LoadDealCardsBidResults implements Action {
  public readonly type = DealCardsBidResultsActionTypes.LoadDealCardsBidResults;
  constructor(public readonly payload: string) {}
}

export class LoadDealCardsBidResultsSuccess implements Action {
  public readonly type = DealCardsBidResultsActionTypes.LoadDealCardsBidResultsSuccess;
  constructor(public readonly dealId: string, public readonly payload: BidResultsWithType) {}
}
export class LoadDealCardsBidResultsFail implements Action {
  public readonly type = DealCardsBidResultsActionTypes.LoadDealCardsBidResultsFail;
  constructor(public readonly dealId: string, public readonly payload: string) {}
}

export type DealCardsBidResultsActionUnion =
  | LoadDealCardsBidResults
  | LoadDealCardsBidResultsSuccess
  | LoadDealCardsBidResultsFail;
